import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './context/AuthContext';
import { CurrencyProvider } from './context/CurrencyContext';
import PrivateRoute from './components/PrivateRoute';
import ShopPage from './pages/ShopPage';
import AccountPage from './pages/AccountPage';
import ProfilePage from './pages/ProfilePage';
import AdminPage from './pages/AdminPage';
import MerchantPage from './pages/MerchantPage';
import SignAgreementPage from './pages/SignAgreementPage';
import VoucherVerifyPage from './pages/VoucherVerifyPage';
import PlatinumVerifyPage from './pages/PlatinumVerifyPage';

export default function App() {
  return (
    <AuthProvider>
      <CurrencyProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<ShopPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route
            path="/profile"
            element={
              <PrivateRoute roles={['shopper', 'admin', 'super_admin']}>
                <ProfilePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <PrivateRoute roles={['admin', 'super_admin']}>
                <AdminPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/merchant"
            element={
              <PrivateRoute roles={['merchant', 'admin', 'super_admin']}>
                <MerchantPage />
              </PrivateRoute>
            }
          />
          <Route path="/sign-agreement/:agreementId" element={<SignAgreementPage />} />
          <Route path="/v/:code" element={<VoucherVerifyPage />} />
          <Route path="/platinum/verify" element={<PlatinumVerifyPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </CurrencyProvider>
    </AuthProvider>
  );
}
